import { createAuthClient } from 'better-auth/react';

// Same-origin in prod (api serves the SPA); in dev Vite proxies /api to the api process.
export const authClient = createAuthClient({
  baseURL: typeof window === 'undefined' ? undefined : window.location.origin,
});

export const { useSession, signIn, signOut } = authClient;
